<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormCanSize
      :CanSize="editCanSize"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormCanSize from '../components/FormCanSize.vue';

export default {
  components: {
    FormCanSize,
  },
  name: 'EditCanSize',
  module: 'CanSize',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing CanSize. Default to {}.
      */
      editCanSize: {},
      /**
       * Query Id for CanSize
       */
      canSizeId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('canSizes', ['canSizes', 'canSize']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.canSizeId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_canSize(this.canSizeId);
      this.editCanSize = this.canSize;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('canSizes', ['LOAD_canSize', 'CREATE_canSize', 'UPDATE_canSize']),
    /** Method used to save the item
     */
    async save(canSize) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_canSize(canSize);
      } else {
        await this.UPDATE_canSize(canSize);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListCanSize' });
    },
  },
};
</script>

<docs>
# EditCanSize example

'''js
<EditCanSize :CanSize="CanSize" />
'''
</docs>
